// extracted by mini-css-extract-plugin
module.exports = {"btncreate":"ButtonCreate_btncreate__16Idb","btncreateLink":"ButtonCreate_btncreateLink__h4yRs"};